import { Datepicker } from 'components/form/Datepicker';
import { FormInput_text } from 'components/form/formInput/FormInput_text';
import { ConfirmationModal } from 'components/modals/ConfirmationModal';
import { AlertMessage } from 'components/notification/AlertMessage';
import { Dropdown } from 'components/filters/Dropdown';
import { Toaster } from 'components/notification/Toaster';
import useAccountControlActions from 'dataflow/billingPortal/actions/useAccountControl.actions';
import { cloneObject, getArrayLength, getObjectLength, isArrayNotEmpty, isDateValid, isNull, isNullUndefined, isStringEmpty } from 'functions';
import { useCustomSelector } from 'hooks';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';

export default function useModals(selectedRows) {
    const [isVisible_updateExpiryDate, setIsVisible_updateExpiryDate] = useState();
    const [newExpiryDate, setNewExpiryDate] = useState();

    const [isVisible_updatePaymentDueDate, setIsVisible_updatePaymentDueDate] = useState();
    const [newPaymentDueDate, setNewPaymentDueDate] = useState();

    const [isVisible_resetPaymentDueDate, setIsVisible_resetPaymentDueDate] = useState();
    const [isVisible_deleteCOM, setIsVisible_deleteCOM] = useState();
    const [isVisible_revertDeletedCOM, setIsVisible_revertDeletedCOM] = useState();

    const [isVisible_updateDealerCode, setIsVisible_updateDealerCode] = useState();
    const [newDealerCodes, setNewDealerCodes] = useState({});

    const [isVisible_updateBillingTag, setIsVisible_updateBillingTag] = useState();
    const [newBillingTags, setNewBillingTags] = useState({});

    const [isVisible_updatePackage, setIsVisible_updatePackage] = useState();
    const [newPackageIds, setNewPackageIds] = useState({});

    const [isModalResetRequired, setIsModalResetRequired] = useState();
    const countdown = useRef(10);
    const interval = useRef();
    const [rerenderValue, setRerenderValue] = useState();

    const [isVisible_setSuspendDate, setIsVisible_setSuspendDate] = useState();
    const [suspendDate, setSuspendDate] = useState();

    // Reset
    useEffect(() => {
        if (!isVisible_updateExpiryDate && !isVisible_updatePaymentDueDate && !isVisible_updateDealerCode && !isVisible_updateBillingTag 
            && !isVisible_updatePackage && !isVisible_setSuspendDate) {
            setNewExpiryDate("");
            setNewPaymentDueDate("");
            setNewDealerCodes({});
            setNewBillingTags({});
            setNewPackageIds({});
            setSuspendDate("");
        }
    }, [isVisible_updateExpiryDate, isVisible_updatePaymentDueDate, isVisible_updateDealerCode, isVisible_updateBillingTag, isVisible_updatePackage, isVisible_setSuspendDate]);

    const {
        updateExpiryDate, updatePaymentDueDate, resetPaymentDueDate,
        deleteCOM, revertDeletedCOM,
        updateDealerCode, updateBillingTag, updatePackage, updateSuspendDate
    } = useAccountControlActions();
    const {
        updateExpiryDate_requesting, updateExpiryDate_isSuccessful,
        updatePaymentDueDate_requesting, updatePaymentDueDate_isSuccessful,
        resetPaymentDueDate_requesting, resetPaymentDueDate_isSuccessful,
        updateDealerCode_requesting, updateDealerCode_isSuccessful,
        updateBillingTag_requesting, updateBillingTag_isSuccessful,
        deleteCOM_requesting, isDeleteCOMSuccessful,
        revertDeletedCOM_requesting, isRevertDeletedCOMSuccessful,
        isUpdateSuccessful,
        setSuspendDate_requesting, setSuspendDate_isSuccessful
    } = useCustomSelector("accountControl");

    useEffect(() => {
        if (isUpdateSuccessful) {
            setIsVisible_deleteCOM(false);
            setIsVisible_resetPaymentDueDate(false);
            setIsVisible_revertDeletedCOM(false);
            setIsVisible_updateBillingTag(false);
            setIsVisible_updateDealerCode(false);
            setIsVisible_updateExpiryDate(false);
            setIsVisible_updatePackage(false);
            setIsVisible_updatePaymentDueDate(false);
            setIsVisible_setSuspendDate(false);
        }
    }, [isUpdateSuccessful]);

    // Reset inputs
    useEffect(() => {
        setIsModalResetRequired(true);
    }, [isVisible_updateExpiryDate, isVisible_updatePaymentDueDate, setIsVisible_updatePackage, isVisible_setSuspendDate]);
    useEffect(() => {
        setIsModalResetRequired(false);
    }, [isModalResetRequired]);

    let updateExpiryDateModal = (
        <ConfirmationModal
            description={"Updating selected COM(s) to new expiry date"}
            input={(
                <Datepicker
                    label={"New Expiry Date"}
                    handleOnChange={setNewExpiryDate}

                    isResetRequired={isModalResetRequired}
                    isConversionRequired_ISO8601
                />
            )}

            cancelButtonText={"Cancel"}
            confirmButtonText={"Confirm"}
            isModalVisible={isVisible_updateExpiryDate}
            updateParentState={setIsVisible_updateExpiryDate}
            handleOnConfirm={() => {
                if (isArrayNotEmpty(selectedRows)) {
                    selectedRows.map((details) => {
                        if (details?.ComId && isDateValid(newExpiryDate)) {
                            updateExpiryDate(details?.ComId, newExpiryDate);
                        }
                        else {
                            Toaster({
                                type: "error",
                                msg: (details?.ComId? "Expiry Date": "COM ID") + " required"
                            })
                        }
                    })
                }
            }}
            isActionLoading={updateExpiryDate_requesting}
            isConfirmSuccessful={updateExpiryDate_isSuccessful}
        />
    );

    let updatePaymentDueDateModal = (
        <ConfirmationModal
            description={"Updating selected COM(s) to new payment due date"}
            input={(
                <Datepicker
                    label={"Date"}
                    handleOnChange={setNewPaymentDueDate}

                    isResetRequired={isModalResetRequired}
                    isConversionRequired_ISO8601
                />
            )}

            cancelButtonText={"Cancel"}
            confirmButtonText={"Confirm"}
            isModalVisible={isVisible_updatePaymentDueDate}
            updateParentState={setIsVisible_updatePaymentDueDate}
            handleOnConfirm={() => {
                if (isArrayNotEmpty(selectedRows)) {
                    selectedRows.map((details) => {
                        if (details?.ComId) {
                            updatePaymentDueDate(details?.ComId, newPaymentDueDate);
                        }
                        else {
                            Toaster({
                                type: "error",
                                msg: "COM ID required"
                            })
                        }
                    })
                }
            }}
            isActionLoading={updatePaymentDueDate_requesting}
            isConfirmSuccessful={updatePaymentDueDate_isSuccessful}
        />
    );

    let resetPaymentDueDateModal = (
        <ConfirmationModal
            bodyHeader={(
                <AlertMessage
                    headerMsg={"WARNING"}
                    message={"BE CAREFUL, THE SELECTED COM(s) PAYMENT DATE WILL BE SET AS EMPTY"}
                    alertType={"error"}
                    isVisible
                />
            )}

            description={(
                <>
                    <div className={""}>
                        Are you sure you want to reset the selected payment dates?
                    </div>

                    <div style={{
                        maxHeight: "100px",
                        overflow: "auto"
                    }}>
                        {isArrayNotEmpty(selectedRows)? selectedRows.map((details, idx) => {
                            return (
                                <div key={idx}>{"COM " + details?.ComId}</div>
                            )
                        }):""}
                    </div>
                </>
            )}
            cancelButtonText={"Cancel"}
            confirmButtonText={"Confirm"}
            isModalVisible={isVisible_resetPaymentDueDate}
            updateParentState={setIsVisible_resetPaymentDueDate}
            handleOnConfirm={() => {
                if (isArrayNotEmpty(selectedRows)) {
                    selectedRows.map((details) => {
                        if (details?.ComId) {
                            resetPaymentDueDate(details?.ComId);
                        }
                        else {
                            Toaster({
                                type: "error",
                                msg: "COM ID required"
                            })
                        }
                    })
                }
            }}
            isActionLoading={resetPaymentDueDate_requesting}
            isConfirmSuccessful={resetPaymentDueDate_isSuccessful}
            isWarning
        />
    );
    useEffect(() => {
        if (isVisible_resetPaymentDueDate) {
            countdown.current = 10;
            interval.current = setTimeout(() => {
                countdown.current = countdown.current - 1;
                setRerenderValue(countdown.current);

                if (countdown.current == 0) {
                    clearTimeout(interval.current);
                }
            }, 1000);
        }
    }, [isVisible_resetPaymentDueDate]);

    let deleteCOMModal = (
        <ConfirmationModal
            bodyHeader={(
                <AlertMessage
                    headerMsg={"WARNING"}
                    message={"BE CAREFUL, THE SELECTED COM(s) WILL BE DELETED"}
                    alertType={"error"}
                    isVisible
                />
            )}

            description={(
                <>
                    <div className={""}>
                        Are you sure you want to delete the selected COM(s)?
                    </div>

                    <div style={{
                        maxHeight: "100px",
                        overflow: "auto"
                    }}>
                        {isArrayNotEmpty(selectedRows)? selectedRows.map((details, idx) => {
                            return (
                                <div key={idx}>{"COM " + details?.ComId}</div>
                            )
                        }):""}
                    </div>
                </>
            )}
            cancelButtonText={"Cancel"}
            confirmButtonText={"Confirm"}
            isModalVisible={isVisible_deleteCOM}
            updateParentState={setIsVisible_deleteCOM}
            handleOnConfirm={() => {
                if (isArrayNotEmpty(selectedRows)) {
                    selectedRows.map((details) => {
                        if (details?.ComId) {
                            deleteCOM(details?.ComId);
                        }
                        else {
                            Toaster({
                                type: "error",
                                msg: "COM ID required"
                            })
                        }
                    })
                }
            }}
            isActionLoading={deleteCOM_requesting}
            isConfirmSuccessful={isDeleteCOMSuccessful}
            isWarning
        />
    );
    useEffect(() => {
        if (isVisible_deleteCOM) {
            countdown.current = 10;
            interval.current = setTimeout(() => {
                countdown.current = countdown.current - 1;
                setRerenderValue(countdown.current);

                if (countdown.current == 0) {
                    clearTimeout(interval.current);
                }
            }, 1000);
        }
    }, [isVisible_deleteCOM]);

    let revertDeletedCOMModal = (
        <ConfirmationModal
            description={(
                <>
                    <div className={""}>
                        Are you sure you want to revert the deletion of the selected COM(s)?
                    </div>

                    <div style={{
                        maxHeight: "100px",
                        overflow: "auto"
                    }}>
                        {isArrayNotEmpty(selectedRows)? selectedRows.map((details, idx) => {
                            return (
                                <div key={idx}>{"COM " + details?.ComId}</div>
                            )
                        }):""}
                    </div>
                </>
            )}
            cancelButtonText={"Cancel"}
            confirmButtonText={"Confirm"}
            isModalVisible={isVisible_revertDeletedCOM}
            updateParentState={setIsVisible_revertDeletedCOM}
            handleOnConfirm={() => {
                if (isArrayNotEmpty(selectedRows)) {
                    selectedRows.map((details) => {
                        if (details?.ComId) {
                            revertDeletedCOM(details?.ComId);
                        }
                        else {
                            Toaster({
                                type: "error",
                                msg: "COM ID required"
                            })
                        }
                    })
                }
            }}
            isActionLoading={revertDeletedCOM_requesting}
            isConfirmSuccessful={isRevertDeletedCOMSuccessful}
            isWarning
        />
    );

    let updateDealerCodeModal = (
        <ConfirmationModal
            description={"Updating selected COM(s) to new dealer code"}
            bodyFooterClassName={"account-control__modal"}
            input={isArrayNotEmpty(selectedRows)? (
                selectedRows.map((details, idx) => {
                    let comId = details?.ComId;

                    return (
                        <div key={idx} className={"inputs-wrapper__inputs d-flex pb-3"}>
                            {/* COM ID */}
                            <FormInput_text
                                className={"inputs__com-id w-50 mr-3"}
                                customInputClassName={"w-100"}
                                inputLabel={"COM ID"}
                                inputValue={comId}

                                isInputOptional
                                isInputDisabled
                                isMarginBtmOptional
                            />

                            {/* New Dealer Code */}
                            <FormInput_text
                                className={"inputs__new-dealer-code w-50"}
                                customInputClassName={"w-100"}
                                inputLabel={"New Dealer Code"}
                                inputValue={newDealerCodes?.[idx]}

                                propagateValueChange={(stateName, value) => { 
                                    let newObj = cloneObject(newDealerCodes);
                                    newObj[idx] = value;
                                    setNewDealerCodes(newObj);
                                }}
                                isResetRequired={!isVisible_updateDealerCode}
                                isMarginBtmOptional
                            />
                        </div>
                    )
                })
            ):""}

            cancelButtonText={"Cancel"}
            confirmButtonText={"Confirm"}
            isModalVisible={isVisible_updateDealerCode}
            updateParentState={setIsVisible_updateDealerCode}
            handleOnConfirm={() => {
                if (isArrayNotEmpty(selectedRows) &&
                    getArrayLength(selectedRows) === getObjectLength(newDealerCodes)) {
                    selectedRows.map((details, idx) => {
                        if (details?.ComId) {
                            updateDealerCode(details?.ComId, newDealerCodes?.[idx]);
                        }
                        else {
                            Toaster({
                                type: "error",
                                msg: "COM ID required"
                            })
                        }
                    })
                }
                else {
                    Toaster({
                        type: "error",
                        msg: "All new dealer code inputs required"
                    })
                }
            }}
            isActionLoading={updateDealerCode_requesting}
            isConfirmSuccessful={updateDealerCode_isSuccessful}
        />
    );

    let updateBillingTagModal = (
        <ConfirmationModal
            description={"Updating selected COM(s) to new billing tag"}
            bodyFooterClassName={"account-control__modal"}
            input={isArrayNotEmpty(selectedRows)? (
                selectedRows.map((details, idx) => {
                    let comId = details?.ComId;

                    return (
                        <div key={idx} className={"inputs-wrapper__inputs d-flex pb-3"}>
                            {/* COM ID */}
                            <FormInput_text
                                className={"inputs__com-id w-50 mr-3"}
                                customInputClassName={"w-100"}
                                inputLabel={"COM ID"}
                                inputValue={comId}

                                isInputOptional
                                isInputDisabled
                                isMarginBtmOptional
                            />

                            {/* New Billing Tag */}
                            <FormInput_text
                                className={"inputs__new-billing-tag w-50"}
                                customInputClassName={"w-100"}
                                inputLabel={"New Billing Tag"}
                                inputValue={newBillingTags?.[idx]}

                                propagateValueChange={(stateName, value) => { 
                                    let newObj = cloneObject(newBillingTags);
                                    newObj[idx] = value;
                                    setNewBillingTags(newObj);
                                }}
                                isResetRequired={!isVisible_updateBillingTag}
                                isMarginBtmOptional
                            />
                        </div>
                    )
                })
            ):""}

            cancelButtonText={"Cancel"}
            confirmButtonText={"Confirm"}
            isModalVisible={isVisible_updateBillingTag}
            updateParentState={setIsVisible_updateBillingTag}
            handleOnConfirm={() => {
                if (isArrayNotEmpty(selectedRows) &&
                    getArrayLength(selectedRows) === getObjectLength(newBillingTags)) {
                    selectedRows.map((details, idx) => {
                        if (details?.ComId) {
                            updateBillingTag(details?.ComId, newBillingTags?.[idx]);
                        }
                        else {
                            Toaster({
                                type: "error",
                                msg: "COM ID required"
                            })
                        }
                    })
                }
                else {
                    Toaster({
                        type: "error",
                        msg: "All new billing tag inputs required"
                    })
                }
            }}
            isActionLoading={updateBillingTag_requesting}
            isConfirmSuccessful={updateBillingTag_isSuccessful}
        />
    );

    const {
        getPackages 
    } = useAccountControlActions();
    const {
        packageList
    } = useCustomSelector("accountControl");
    useEffect(() => {
        getPackages();
    }, []);
    useEffect(() => {
        if (isArrayNotEmpty(selectedRows) && isArrayNotEmpty(packageList)) {
            setNewPackageIds(packageList.find((obj) => (obj?.PackageName && selectedRows[0]?.PackageName) && 
                obj?.PackageName == selectedRows[0]?.PackageName)?.PackageID);
        }
    }, [isVisible_updatePackage, JSON.stringify(packageList)]);

    let updatePackageModal = (
        <ConfirmationModal
            description={"Updating selected COM(s) to new package"}
            bodyFooterClassName={"account-control__modal " + (selectedRows?.length > 3? "account-control__modal_overflow ":"")}
            input={isArrayNotEmpty(selectedRows)? (
                selectedRows.map((details, idx) => {
                    let comId = details?.ComId;

                    return (
                        <div key={idx} className={"inputs-wrapper__inputs d-flex pb-3"}>
                            {/* COM ID */}
                            <FormInput_text
                                className={"inputs__com-id w-50 mr-3"}
                                customInputClassName={"w-100"}
                                inputLabel={"COM ID"}
                                inputValue={comId}

                                isInputOptional
                                isInputDisabled
                                isMarginBtmOptional
                            />

                            {/* New Package */}
                            <Dropdown
                                className={"inputs__new-package w-50"}
                                label={"New Package"}
                                isInputRequired

                                selectedValue_default={newPackageIds?.[idx]}
                                valueFromParent={newPackageIds?.[idx]}

                                options={isArrayNotEmpty(packageList) && packageList.map((obj) => {
                                    return {
                                        label: obj?.PackageName,
                                        value: obj?.PackageID,
                                    }
                                })}
                                onChange={(value) => { 
                                    let newObj = cloneObject(newPackageIds);
                                    newObj[idx] = value;
                                    setNewPackageIds(newObj);
                                }}

                                isResetRequired={!isVisible_updatePackage}
                            />
                        </div>
                    )
                })
            ):""}

            cancelButtonText={"Cancel"}
            confirmButtonText={"Confirm"}
            isModalVisible={isVisible_updatePackage}
            updateParentState={setIsVisible_updatePackage}
            handleOnConfirm={() => {
                if (isArrayNotEmpty(selectedRows) &&
                    getArrayLength(selectedRows) === getObjectLength(newPackageIds)) {
                    selectedRows.map((details, idx) => {
                        if (details?.ComId) {
                            updatePackage(details?.ComId, newPackageIds?.[idx]);
                        }
                        else {
                            Toaster({
                                type: "error",
                                msg: "COM ID required"
                            })
                        }
                    })
                }
                else {
                    Toaster({
                        type: "error",
                        msg: "New package input(s) required"
                    })
                }
            }}
            isActionLoading={updateDealerCode_requesting}
            isConfirmSuccessful={updateDealerCode_isSuccessful}
        />
    );

    let setSuspendDateModal = (
        <ConfirmationModal
            description={"Set selected COM(s) suspend date"}
            input={(
                <Datepicker
                    label={"Suspend Date"}
                    handleOnChange={setSuspendDate}

                    isResetRequired={isModalResetRequired}
                    isConversionRequired_ISO8601
                    minDate={new Date(new Date().setDate(new Date().getDate() + 1))} // date after the current date
                />
            )}

            cancelButtonText={"Cancel"}
            confirmButtonText={"Confirm"}
            isModalVisible={isVisible_setSuspendDate}
            updateParentState={setIsVisible_setSuspendDate}
            handleOnConfirm={() => {
                // only com with suspend date can set to null
                // if suspend date null check if current value has suspend date
                if(!isDateValid(suspendDate)) {
                    for(let i = 0; i < selectedRows.length; i++) {
                        let suspendDate = selectedRows[i]?.SuspendDate
                        if(isNullUndefined(suspendDate) || isStringEmpty(suspendDate)) {
                            Toaster({
                                type: "error",
                                msg: "Suspend Date cannot set to null"
                            })
                            return;
                        }
                    }
                }

                if (isArrayNotEmpty(selectedRows)) {
                    selectedRows.map((details) => {
                        if (details?.ComId) {
                            updateSuspendDate(details?.ComId, suspendDate);
                        }
                        else {
                            Toaster({
                                type: "error",
                                msg: "COM ID required"
                            })
                        }
                    })
                }
            }}
            isActionLoading={setSuspendDate_requesting}
            isConfirmSuccessful={setSuspendDate_isSuccessful}
        />
    );

    return {
        updateExpiryDateModal, updatePaymentDueDateModal, resetPaymentDueDateModal, updateDealerCodeModal, 
        updateBillingTagModal, updatePackageModal, deleteCOMModal, revertDeletedCOMModal, setSuspendDateModal, 
        setIsVisible_updateExpiryDate, setIsVisible_updatePaymentDueDate, setIsVisible_setSuspendDate,
        setIsVisible_resetPaymentDueDate, setIsVisible_deleteCOM, setIsVisible_revertDeletedCOM,
        setIsVisible_updateDealerCode, setIsVisible_updateBillingTag, setIsVisible_updatePackage
    }
}